import { UPDATE_PURCHASE } from "../../types/PurchaseType";
import axios from "axios";
import { toast } from "react-toastify";

const updatePurchaseAction = (data) => {
  return {
    type: UPDATE_PURCHASE,
    payload: data,
  };
};

export const updatePurchase = (id, values) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "put",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `purchase-invoice/${id}`,
        data: { ...values },
      });

      const newData = {
        ...data.updatedInvoice,
        supplier: data.supplier,
      };

      dispatch(updatePurchaseAction(newData));
      toast.success("Purchase invoice updated successfully");
      return {
        createdInvoiceId: data.updatedInvoice.id,
        message: "success",
      };
    } catch (error) {
      console.error(error.message);
      toast.error("Error updating purchase invoice");
      return { message: "error" };
    }
  };
};
